import constants from 'constants';

const {
  ADD_LANDING_DATA,
  ADD_LANDING_DATA_USER,
  ADD_ABOUT_DATA,
  ADD_ABOUT_DATA_USER
} = constants;

const landingData = (landingData = {
  body: '',
  about_us: '',
  isLoaded: false
}, {
  type,
  payload
}) => {
  switch (type) {
    case ADD_LANDING_DATA:
      return {
        ...landingData,
        ...{
          body: payload.data,
          isLoaded: true
        }
      }
    case ADD_LANDING_DATA_USER:
      return {
        ...landingData,
        ...{
          body: payload.data,
          isLoaded: true
        }
      }
    case ADD_ABOUT_DATA:
      return {
        ...landingData,
        ...{
          about_us: payload.data,
          isLoaded: true
        }
      }
    case ADD_ABOUT_DATA_USER:
      return {
        ...landingData,
        ...{
          about_us: payload.data,
          isLoaded: true
        }
      }
    default: return landingData
  }
}

export { landingData };



// WEBPACK FOOTER //
// ./src/reducers/landing.js